import { render, staticRenderFns } from "./CellSchool.vue?vue&type=template&id=69242767&scoped=true"
import script from "./CellSchool.vue?vue&type=script&lang=js"
export * from "./CellSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69242767",
  null
  
)

export default component.exports